(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react-redux"));
	else if(typeof define === 'function' && define.amd)
		define(["react-redux"], factory);
	else if(typeof exports === 'object')
		exports["redux-responsive"] = factory(require("react-redux"));
	else
		root["redux-responsive"] = factory(root["react-redux"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_13__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition